import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../context/AuthContext";

import TypewriterText from "./TypewriterText";

import ModalConfirm from "../modals/Modal";
import Modal from "../modals/ModalSelectPokemon";

import styles from "../styles/StarterSelection.module.css";

import typeChart from "../utils/data/typeChart.json";

const StarterSelection = () => {
  const [starters, setStarters] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedPokemonModal, setSelectedPokemonModal] = useState(null);
  const [
    selectedPokemonConfirmationModal,
    setSelectedPokemonConfirmationModal,
  ] = useState(null);
  const { user, token, updateUserData } = useAuthContext();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [rerollCount, setRerollCount] = useState(5);
  const [rerollTypeCount, setRerollTypeCount] = useState(1);
  const [selectedType, setSelectedType] = useState(null);
  const [hasSelectedType, setHasSelectedType] = useState(false);
  const [showIntro, setShowIntro] = useState(true);

  const types = Object.entries(typeChart).map(([type, path]) => ({
    name: type,
    path: path,
  }));

  const fetchStarters = async () => {
    setIsLoading(true);
    try {
      const url = `https://api.poketask.fr/api/starter${
        selectedType ? `?type=${selectedType}` : ""
      }`;
      console.log("URL de la requête:", url); // Pour déboguer
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("Réponse du serveur:", response.data); // Pour déboguer
      setStarters(response.data);
    } catch (error) {
      console.error("Erreur complète:", error.response || error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStarters();
  }, [selectedType]);

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const response = await axios.get("https://api.poketask.fr/api/starter");
        // Extraire tous les types uniques des tableaux de types
        const allTypes = response.data.flatMap((pokemon) =>
          JSON.parse(pokemon.type)
        );
        const uniqueTypes = [...new Set(allTypes)].sort();
        console.log("Types disponibles:", uniqueTypes);
        // Optionnel : mettre à jour la liste des types
        // setTypes(uniqueTypes);
      } catch (error) {
        console.error("Erreur lors de la récupération des types:", error);
      }
    };
    fetchTypes();
  }, []);

  if (user && user.hasSelectedStarter) {
    console.log("starter détecté");
    navigate("/");
  }

  const selectStarter = (pokemonId) => {
    setLoading(true);
    console.log("Pokemon ID sélectionné :", pokemonId);

    axios
      .post(
        "https://api.poketask.fr/api/capture",
        {
          utilisateur_id: user.id,
          pokemon_id: pokemonId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then(async () => {
        console.log("Starter sélectionné avec succès !");
        setSelected(pokemonId);

        // Mettre à jour les données utilisateur
        await updateUserData();

        setTimeout(() => {
          navigate("/dashboard");
        }, 1000);
      })
      .catch((error) => {
        console.error("Erreur lors de la sélection :", error);
        setLoading(false);
        console.log(error.response);
      });
  };

  const handleOpenModal = (pokemonId) => {
    setSelectedPokemonModal(pokemonId);
  };

  const handleCloseModal = () => {
    setSelectedPokemonModal(null);
  };

  const handleReroll = () => {
    if (rerollCount > 0) {
      setRerollCount((prev) => prev - 1);
      setSelected(null);
      setSelectedPokemonModal(null);
      fetchStarters();
    }
  };

  const handleTypeChange = (e) => {
    if (!hasSelectedType) {
      setSelectedType(e.target.value || null);
      setHasSelectedType(true);
    }
  };

  const handleWheel = (e) => {
    if (e.deltaY !== 0) {
      e.preventDefault();
      const container = e.currentTarget;
      container.scrollLeft += e.deltaY;
    }
  };

  if (!user) {
    return <p>Chargement...</p>;
  }

  const getTypeIcons = (typeJson) => {
    try {
      const types = JSON.parse(typeJson);
      const icons = types.map((type) => {
        // Garder la casse d'origine car les clés dans typeChart sont en majuscules
        const iconPath = typeChart[type];
        console.log(`Type: ${type}, Icon path: ${iconPath}`);
        // Utiliser directement le chemin du typeChart
        return iconPath || "";
      });
      return icons;
    } catch (error) {
      console.error("Erreur lors du parsing du type:", error);
      return [];
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.intro}>
        <div className={styles.fadeBackground}></div>
        {showIntro && (
          <div className={styles.introScene}>
            <div className={styles.introScene_img}>
              <img src="/assets/intro/intro.png" alt="intro" />
            </div>
            <TypewriterText onComplete={() => setShowIntro(false)} />
          </div>
        )}
      </div>
      <div className={styles.header}>
        <div className={styles.controlsContainer}>
          <div className={styles.controls}>
            <div className={styles.typeContainer} onWheel={handleWheel}>
              <button
                className={`${styles.typeButton} ${
                  !selectedType ? styles.selected : ""
                }`}
                onClick={() => handleTypeChange({ target: { value: "" } })}
                disabled={isLoading || selected !== null || hasSelectedType}
              >
                <p className={styles.space} style={{ padding: "0px" }}>
                  test
                </p>
              </button>
              {types.map((type) => (
                <button
                  key={type.name}
                  className={`${styles.typeButton} ${
                    selectedType === type.name ? styles.selected : ""
                  }`}
                  onClick={() =>
                    handleTypeChange({ target: { value: type.name } })
                  }
                  disabled={isLoading || selected !== null || hasSelectedType}
                >
                  <img
                    src={type.path}
                    alt={type.name}
                    className={styles.typeIcon}
                  />
                </button>
              ))}
            </div>
          </div>
          <div className={styles.rerollContainer}>
            <button
              onClick={handleReroll}
              disabled={isLoading || selected !== null || rerollCount === 0}
              className={styles.rerollButton}
            >
              <img src="/assets/icons/reload.svg" alt="reroll" />
              <p className={styles.rerollCount}>
                {isLoading ? "" : `${rerollCount}`}
              </p>
            </button>
          </div>
        </div>
      </div>

      <div className={styles.plankContainer}>
        <img
          className={styles.plank}
          src="/assets/intro/plank_full.png"
          alt="plank"
        />
      </div>
      <div
        className={styles.container}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div className={styles.selectionContainer}>
          {starters.map((pokemon) => (
            <div className={styles.pokeballContainer} key={pokemon.id}>
              <div className={styles.ballShadow}></div>

              <img
                src="/assets/icons/pokeball2.png"
                alt="pokeball"
                className={styles.pokeball}
                onClick={() => handleOpenModal(pokemon.id)}
              />
              {selectedPokemonModal === pokemon.id && (
                <Modal
                  pokemonName={pokemon.nom}
                  isOpen={true}
                  onClose={handleCloseModal}
                  className={styles.modal}
                >
                  <div className={styles.modalContainer}>
                    <div className={styles.modalContent}>
                      <div className={styles.nameContainer}>
                        <div className={styles.name}>
                          <p>{pokemon.nom}</p>
                        </div>
                        <div className={styles.typeIcons}>
                          {getTypeIcons(pokemon.type).map((iconPath, index) => {
                            console.log(
                              `Rendering icon ${index} with path:`,
                              iconPath
                            ); // Pour déboguer
                            return (
                              <img
                                key={index}
                                src={iconPath}
                                alt={`Type ${index + 1}`}
                                className={styles.typeIcon}
                              />
                            );
                          })}
                        </div>
                        <div></div>
                      </div>
                      <div className={styles.videoContainer}>
                        <video
                          src={pokemon.video}
                          alt={pokemon.nom}
                          autoPlay
                          loop
                          muted
                          width={120}
                        />
                      </div>
                    </div>
                    <div className={styles.buttons}>
                      <button
                        onClick={() =>
                          setSelectedPokemonConfirmationModal(true)
                        }
                        disabled={selected !== null || loading}
                      >
                        <div
                          className={`${styles.connect_button}`}
                          style={{
                            backgroundColor: "rgba(6, 202, 88, 0.768)",
                          }}
                        >
                          {loading ? "Chargement..." : "Choisir"}
                        </div>
                      </button>
                      <button
                        onClick={() => setSelectedPokemonModal(false)}
                        disabled={selected !== null || loading}
                      >
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 669 774"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M345.71 0.439453H93.33C78.07 0.439453 65.7 12.8095 65.7 28.0695C65.7 43.3295 78.07 55.6994 93.33 55.6994H345.71C491.47 55.6994 610.33 173.039 612.79 318.229C615.32 467.649 489.08 589.949 339.64 589.949H94.31L95.48 588.829L170.66 513.649C181.45 502.859 181.45 485.359 170.66 474.569C159.87 463.779 142.37 463.779 131.58 474.569L9.04001 597.109C-1.74999 607.899 -1.74999 625.399 9.04001 636.189L138.31 765.459C149.1 776.249 166.6 776.249 177.39 765.459C188.18 754.669 188.18 737.169 177.39 726.379L96.23 645.219H338.85C514.28 645.219 662.75 507.929 667.95 332.579C673.35 150.379 526.71 0.439453 345.71 0.439453Z"
                            fill="#34221e65"
                          />
                        </svg>
                      </button>
                    </div>
                    {/* <div className={styles.modalException}>
                                            {pokemon.nom === 'Mew' ? <p>"Je.. Euh..... il n'est pas censé être là lui, mais bon si il y tient.. On peut dire que tu as beaucoup de chance.."</p> : ""}
                                        </div> */}
                  </div>
                  {selectedPokemonConfirmationModal && (
                    <ModalConfirm
                      pokemon={pokemon}
                      className={styles.modalConfirm}
                      isOpen={selectedPokemonConfirmationModal}
                      onClose={() => setSelectedPokemonConfirmationModal(false)}
                    >
                      <div className={styles.confirmationContent}>
                        <div className={styles.confirmationBody}>
                          <div className={styles.illustration}>
                            <img src={pokemon.illustration} alt="" />
                          </div>
                            <div className={styles.body}>
                            <p>
                            {pokemon.nom} ? C'est un excellent choix, mais tu ne
                            pourras pas revenir en arrière, c'est ton dernier
                            mot ?
                          </p>
                          <div className={styles.confirmationButtons}>
                            <button
                              className={styles.connect_button}
                              onClick={() => selectStarter(pokemon.id)}
                            >
                              Oui
                            </button>
                            <button
                            className={styles.connect_button}
                            style={{backgroundColor: 'rgb(255,255,255,0.5)', border: 'solid 3px rgb(0,0,0,0.2)', color: 'rgb(0,0,0,0.5)', fontSize: '0.8rem'}}
                              onClick={() =>
                                setSelectedPokemonConfirmationModal(false)
                              }
                            >
                              Finalement..
                            </button>
                          </div>
                            </div>
                        </div>
                      </div>
                    </ModalConfirm>
                  )}
                </Modal>
              )}
            </div>
          ))}
        </div>
      </div>

      {selected && <p>Tu as choisi ton starter !</p>}
    </div>
  );
};

export default StarterSelection;
